import axiosInstance from "./axios";

const ERROR_CONSTANTS = {
  GENERIC_ERROR: "Something went wrong, Please try again!",
};

const getErrorMessageListFromApiResponse = (error) => {
  return (
    error?.response?.data?.errors || [
      { message: ERROR_CONSTANTS.GENERIC_ERROR },
    ]
  );
};

const axiosCall = async ({
  url,
  method,
  body = undefined,
  headers = {},
  params = {},
  responseType = undefined,
  onUploadProgress = undefined,
}) => {
  const http = axiosInstance;
  try {
    const { data, status } = await http.request({
      url,
      method,
      data: body,
      params: {
        ...params,
      },
      headers,
      responseType,
      timeout: 120 * 1000,
      onUploadProgress,
    });
    return { data, errors: [], statusCode: status };
  } catch (error) {
    const errorList = getErrorMessageListFromApiResponse(error);
    return {
      data: null,
      errors: errorList,
      statusCode: error?.response?.status,
    };
  }
};

const httpClient = {
  get: (args) => axiosCall({ ...args, method: "GET" }),
  post: (args) => axiosCall({ ...args, method: "POST" }),
  put: (args) => axiosCall({ ...args, method: "PUT" }),
  delete: (args) => axiosCall({ ...args, method: "DELETE" }),
  patch: (args) => axiosCall({ ...args, method: "PATCH" }),
};

export default httpClient;
